import React, { useCallback, useEffect, useState } from 'react';
import './Dropzone.scss';
import { useDropzone } from 'react-dropzone';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkCircle } from '@fortawesome/free-solid-svg-icons';

const propTypes = {
  onUpload: PropTypes.func,
  className: PropTypes.string,
  accept: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  showAsImage: PropTypes.bool,
};
const defaultProps = {
  onUpload: () => null,
  className: '',
  accept: '',
  disabled: false,
  value: '',
  showAsImage: false,
};

export default function Dropzone(props) {
  const { onUpload, className, accept, disabled, value, showAsImage } = props;
  const [files, setFiles] = useState(null);
  const [isImage, setIsImage] = useState(false);
  const [error, setError] = useState('');
  const [uid] = useState(new Date().getTime().toString());
  const [fileTypes, setFileTypes] = useState({});

  const onDrop = useCallback((acceptedFiles) => {
    setError('');

    if (acceptedFiles.length > 0) {
      const [file] = acceptedFiles;
      setFiles(acceptedFiles);
      onUpload(acceptedFiles);

      if (file.type.toString().startsWith('image/')) {
        setIsImage(true);
        const reader = new FileReader();
        const imgPreview = new Image();

        reader.onload = (res) => {
          imgPreview.src = res.target.result;

          setTimeout(() => {
            const cont = document.querySelector(`#dropzone-img-preview-${uid}`);
            if (cont) {
              cont.innerHTML = '';
              if (cont) {
                cont.appendChild(imgPreview);
              }
            }
          }, 500);
        };

        reader.readAsDataURL(file);
      } else {
        const img = document.querySelector(`#dropzone-img-preview-${uid} img`);
        if (img) {
          img.remove();
        }
        setTimeout(() => setIsImage(false), 500);
      }
    } else {
      setError('No file select or file type is not allowed.');
      setTimeout(() => setError(''), 1000);
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: fileTypes,
    noClick: true,
    noKeyboard: true,
    maxFiles: 1,
  });

  const openDropZoneInput = () => {
    const input = document.getElementById(`drop-zone-input-${uid}`);
    input.click();
  };

  useEffect(() => {
    if (accept) {
      const temp = {};
      temp[accept] = [];
      setFileTypes(temp);
    }

    if (value) {
      setIsImage(value.match(/\.(jpeg|jpg|gif|png|svg)$/) != null);
    }
  }, [accept, value]);

  return (
    <div
      className={`select-file container w-100 d-flex align-items-center justify-content-center ${className}`}
    >
      {error.length > 0 && (
        <div className="d-block mb-1 position-absolute" style={{ zIndex: 99 }}>
          <p className="alert alert-danger text-center p-2 m-0">
            <FontAwesomeIcon icon={faXmarkCircle} /> {error}
          </p>
        </div>
      )}
      <div {...getRootProps({ className: 'dropzone' })}>
        <input
          {...getInputProps()}
          accept={accept}
          disabled={disabled}
          id={`drop-zone-input-${uid}`}
        />
        {files && (
          <div className="with-file">
            <div className="d-block w-50" id={`dropzone-img-preview-${uid}`}>
              {!isImage && (
                <div className="file-details p-2">
                  <p className="alert alert-info">{files[0].path}</p>
                </div>
              )}
            </div>
            <div className="d-flex w-50 flex-column align-content-center align-items-center justify-content-center">
              <p>Drop file here to replace file</p>
              <Button
                variant="primary"
                size="sm"
                type="button"
                className="file-browse"
                onClick={openDropZoneInput}
                disabled={disabled}
              >
                Replace File
              </Button>
            </div>
          </div>
        )}
        {!files && showAsImage && value.length > 0 && (
          <div className="with-file">
            <div className="d-block w-50" id={`dropzone-img-preview-${uid}`}>
              {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
              <img src={value} alt="Preview Image" />
            </div>
            <div className="d-flex w-50 flex-column align-content-center align-items-center justify-content-center">
              <p>Drop file here to replace file</p>
              <Button
                variant="primary"
                size="sm"
                type="button"
                className="file-browse"
                onClick={openDropZoneInput}
                disabled={disabled}
              >
                Replace File
              </Button>
            </div>
          </div>
        )}
        {!files && !showAsImage && value.length > 0 && (
          <div className="with-file flex-column">
            <div className="d-block">
              <div className="file-details p-2">
                <p
                  className="small alert alert-info m-0 p-2 w-100 overflow-auto"
                  style={{ zIndex: 9, maxHeight: '100px' }}
                >
                  <a href={value} target="_new" rel="noreferrer">
                    {value}
                  </a>
                </p>
              </div>
            </div>
            <div className="d-flex flex-column align-content-center align-items-center justify-content-center">
              <p>Drop file here to replace file</p>
              <Button
                variant="primary"
                size="sm"
                type="button"
                className="file-browse"
                onClick={openDropZoneInput}
                disabled={disabled}
              >
                Replace File
              </Button>
            </div>
          </div>
        )}
        {!files && value.length === 0 && (
          <div className="d-flex flex-column align-content-center align-items-center justify-content-center">
            <p>Drop file here to upload</p>
            <Button
              variant="primary"
              size="sm"
              type="button"
              className="file-browse"
              onClick={openDropZoneInput}
              disabled={disabled}
            >
              Select File
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

Dropzone.propTypes = propTypes;
Dropzone.defaultProps = defaultProps;
